import { flexWrapper } from "packages/membership/pages/ReferAFriend/RafBanner/RafBanner.css";
import React from "react";
import { counterContainer, numberText, uppercaseText } from "./Countdown.css";
import { useCountdown } from "./useCountdown";

type DateTimeDisplayProps = {
  value: number;
  type: string;
};
const DateTimeDisplay = ({
  value,
  type
}: DateTimeDisplayProps): JSX.Element => {
  return (
    <p className={flexWrapper}>
      <span className={numberText}>{value > 9 ? value : `0${value}`}</span>
      <span className={uppercaseText}>{type}</span>
    </p>
  );
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <div data-testid="Countdown" className={counterContainer}>
      <DateTimeDisplay value={days} type="DAYS" />
      <DateTimeDisplay value={hours} type="HRS" />
      <DateTimeDisplay value={minutes} type="MINS" />
      <DateTimeDisplay value={seconds} type="SECS" />
    </div>
  );
};

type Props = {
  targetDate: string;
};

export const CountdownTimer = ({ targetDate }: Props): JSX.Element | null => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return null;
  }
  return (
    <ShowCounter
      days={days}
      hours={hours}
      minutes={minutes}
      seconds={seconds}
    />
  );
};
